module.exports = __webpack_public_path__ + "img/jinlianmeng.8e9ee84d.png";